const Button = ({ text, onClick, className = '', type = 'button', disabled = false }) => {
    return <button type={type} className={`button-primary primary-bg primary-font ${className}`.trim()} onClick={onClick} disabled={disabled}>{text}</button>
};

export default Button;